/* eslint-disable */
var axios = require('./axios/lib/axios');

var Bmob = require('./bmob');

var setHeader = function setHeader(config) {
  var type = 'wechatApp';

  if (Bmob.type === 'nodejs') {
    type = 'cloudcode';
  }

  var header = {
    'content-type': 'application/json',
    'X-Bmob-SDK-Type': type,
    'X-Bmob-Application-Id': config.applicationId,
    'X-Bmob-REST-API-Key': config.applicationKey
  };

  if (config.applicationMasterKey) {
    header['X-Bmob-Master-Key'] = config.applicationMasterKey;
  }

  return header;
};

var request = function request(route) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  var parma = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (resolve, reject) {
    if (undefined === Bmob.User) {
      Bmob = require('./bmob');
    }

    var header = setHeader(Bmob._config);
    var current = Bmob.User.current();

    if (current) {
      header['X-Bmob-Session-Token'] = current.sessionToken;
    }

    var server = axios.create({
      baseURL: Bmob._config.host,
      headers: header,
      validateStatus: function validateStatus(status) {
        return status < 500; // 状态码在大于或等于500时才会 reject
      }
    });
    var serverData = {
      url: route,
      method: method
    };

    if (serverData.method === 'get') {
      serverData.params = parma;
    } else {
      serverData.data = parma;
    }

    server(serverData).then(function (_ref) {
      var data = _ref.data;

      if (data.code && data.error || data.error) {
        reject(data);
      }

      resolve(data);
    }).catch(function (err) {
      reject(err);
    });
  });
};

module.exports = request;